import { Masonry, Typography } from '@forgeglobal/design-framework';
import AccountDetailsCard from '@tcs/client-portal-common/components/templates/DetailCards/AccountDetailsCard';
import BeneficiariesCard from '@tcs/client-portal-common/components/templates/DetailCards/BeneficiariesCard';
import useAccount from '@tcs/client-portal-common/hooks/useAccount';
import Spinner from '@tcs/common/components/atoms/Spinner';
import useMasonryDynamicColumns from '@tcs/common/hooks/useMasonryDynamicColumns';
import { useStyles } from './AccountDetails.style';

interface Props {
  title?: boolean;
  accountNumber: string;
  showBeneficiaries?: boolean;
  editEnabled?: boolean;
}

const AccountDetails = ({
  title,
  accountNumber,
  showBeneficiaries = true,
  editEnabled = true,
}: Props) => {
  const classes = useStyles();
  const { loading, data: account } = useAccount(accountNumber);
  const dynamicColumns = useMasonryDynamicColumns('lg', 2);

  if (loading) {
    return <Spinner />;
  }

  const { displayAccountType, effectiveDate, status } = account;

  if (!account) {
    // @TODO: account not found. Show no data page
    return null;
  }

  return (
    <>
      {title && (
        <Typography
          variant="h5"
          className={
            classes.title
          }>{`${displayAccountType} ${accountNumber}`}</Typography>
      )}
      <Masonry numCols={dynamicColumns}>
        <AccountDetailsCard
          accountNumber={accountNumber}
          accountType={displayAccountType}
          status={status}
          effectiveDate={effectiveDate}
        />
        {showBeneficiaries && (
          <BeneficiariesCard
            accountNumber={accountNumber}
            editEnabled={editEnabled}
          />
        )}
      </Masonry>
    </>
  );
};

export default AccountDetails;
